import React from "react";
import { Button, Form } from "antd";
// import { useNavigate } from "react-router-dom";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import { LoginRequest } from "./Validation";
import { useDispatch } from "react-redux";
import { doLogin } from "../../../store/AuthSlice";
import { AppDispatch } from "../../../store/app";
import { Link, useNavigate } from "react-router-dom";
// import { stringDecryption } from '../../../config/Global';
import { assignErrorToInput } from "../../../store/api";
import Logo from "../../../assets/images/logo.svg";

const LoginForm: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  // const [rememberMe, setRememberMe] = useState(false);
  // const Auth = useSelector((state: RootState) => state.AUTH);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleSubmit = (data: any) => {
    dispatch(doLogin(data))
      .then(() => {
        navigate("/dashboard");
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.notification);
      });
  };

  // useEffect(() => {
  //   let rememberMe: any = localStorage.getItem('remember_me');
  //   if (rememberMe) {
  //     rememberMe = JSON.parse(stringDecryption(rememberMe));
  //     form.setFieldsValue({
  //       username: rememberMe.email,
  //       password: rememberMe.password,
  //       remember: true,
  //     });
  //     // setRememberMe(true);
  //   }
  // }, [form]);

  return (
    <div className="loginForm">
      <div className="loginFormWrap">
        <img src={Logo} alt="logo" className="logo" />
        <div className="formTitle">
          <h2 className="title">Welcome</h2>
        </div>
        <FormBox form={form} onFinish={handleSubmit}>
          <InputBox.Text
            name="username"
            label={"Username"}
            placeholder="username"
            required
            rules={LoginRequest().user("User Name")}
          />
          <InputBox.Password
            name="password"
            label="Password"
            placeholder="xxxxxxx"
            rules={LoginRequest().password("Password")}
          />
          <div className="text-center">
            <Button
              // loading={Auth.isLoading}
              type="primary"
              htmlType="submit"
            >
              Login
            </Button>
          </div>
          <div
            className="mt-10 font-medium login_extra_fields"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {/* <Checkbox
              name="remember_me"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
            >
              Remember me
            </Checkbox> */}
            <Link to="/register">Register Now</Link>
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
        </FormBox>
      </div>
    </div>
  );
};

export default LoginForm;
